import { CardContent, Typography, Button, Avatar, Card } from '@ui/components';
import { Warning } from '@ui/components/icons';
import { useTranslation } from 'react-i18next';
import { useCurrentUser } from '@shared/hooks';
import { useNavigate } from 'react-router-dom';
import { Routes } from '@shared/enums';
import { FC } from 'react';

export const NotFound: FC = () => {
  const { user, setUserCompany } = useCurrentUser();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const companiesPicker = (
    <Card className="min-w-1/3 pt-4 border border-border-default">
      <CardContent>
        {user?.companies.map((company) => (
          <Button
            onClick={() => setUserCompany(company.id!)}
            className="justify-start flex gap-4 w-full"
            key={company.id}
            variant="ghost"
            size="large"
          >
            <Avatar fallback={company.name} />
            <div className="flex flex-col items-baseline">
              <Typography className="text-default max-w-48 truncate" variant="labelMediumMedium">
                {company.name}
              </Typography>
              <Typography variant="labelSmallBook" className="text-weak">
                {t(`AUTH.ROLE.${company.role}`)}
              </Typography>
            </div>
          </Button>
        ))}
      </CardContent>
    </Card>
  );

  const goToDashboardButton = (
    <Button onClick={() => navigate(Routes.ROOT)} size="large">
      {t('NOT_FOUND.GO_TO_DASHBOARD')}
    </Button>
  );

  return (
    <main className="p-8 h-screen w-screen overflow-hidden bg-cover bg-[url('../images/background.svg')]">
      <Card className="size-full flex flex-col gap-8 items-center justify-center">
        <div className="size-20 bg-surface-hover rounded-full flex items-center justify-center">
          <Warning className="size-12 text-border-disabled" />
        </div>

        <Typography className="text-weak" variant="h600">
          {t('NOT_FOUND.TITLE')}
        </Typography>

        {user?.companies && user.companies.length > 1 ? companiesPicker : goToDashboardButton}
      </Card>
    </main>
  );
};
